/** Icônes du planning v2 (trait 2, comme les icônes `ic()` de la maquette /msc). Décoratives : aria-hidden. */
type IconProps = { size?: number };

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2.2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false,
});

export const IconLeft = ({ size = 16 }: IconProps) => (
  <svg {...base(size)}>
    <path d="m15 18-6-6 6-6" />
  </svg>
);

export const IconRight = ({ size = 16 }: IconProps) => (
  <svg {...base(size)}>
    <path d="m9 18 6-6-6-6" />
  </svg>
);

export const IconClose = ({ size = 14 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const IconInfo = ({ size = 18 }: IconProps) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 8h.01" />
  </svg>
);

export const IconExternal = ({ size = 11, className }: IconProps & { className?: string }) => (
  <svg {...base(size)} className={className}>
    <path d="M7 17 17 7M9 7h8v8" />
  </svg>
);
